import { useEffect, useState } from "react";

import { useLeagues } from "../../../hooks/useLeagues";

import {
  IoAddOutline,
  IoCheckmarkCircle,
  IoCloseCircle,
} from "react-icons/io5";

import { AppContainer } from "../../components";

export const AdminLeagues = () => {
  const { getLeagues, updateLeagueStatus } = useLeagues();

  const [leagues, setLeagues] = useState([]);

  useEffect(() => {
    const getLeaguesAsync = async () => {
      const leagues = await getLeagues("false");
      setLeagues(leagues);
    };
    getLeaguesAsync();
  }, []);

  return (
    <AppContainer>
      <div className='flex h-full w-full flex-col items-center px-5 z-20'>
        <div className='mt-5 flex w-full max-w-[480px] items-center justify-between'>
          <div className='w-full flex items-center justify-center'>
            <p className='text-xl text-white font-bold text-center w-[50vw] mt-5'>
              Administración de ligas
            </p>
          </div>
          <button
            type='button'
            disabled
            title='Disponible al conectar el servicio de ligas'
            className='flex h-8 w-8 items-center justify-center rounded-full border border-white/20 text-white/30 cursor-not-allowed absolute right-5 '
            aria-label='Agregar liga'>
            <IoAddOutline className='h-4 w-4' />
          </button>
        </div>

        <div className='mt-10 w-[90%] max-w-[480px] flex-1 overflow-y-auto divide-y divide-white/10 '>
          {leagues.length ? (
            leagues.map((league) => (
              <article
                key={league.id}
                className='flex items-center justify-between py-3 text-[11px]'>
                <img
                  src={league.img}
                  alt={league.name}
                  className='w-5 object-contain'
                />
                <div className='min-w-0 w-full ml-5'>
                  <p
                    className={`truncate font-medium ${league.status === "ACTIVE" ? "text-white" : "text-white/40"}`}>
                    {league.name}
                  </p>
                </div>
                <button
                  type='button'
                  title='Disponible al conectar el servicio de ligas'
                  className='ml-4 cursor-not-allowed'
                  aria-label={
                    league.status === "ACTIVE"
                      ? "Desactivar liga"
                      : "Activar liga"
                  }
                  onClick={async () => {
                    const newStatus =
                      league.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
                    await updateLeagueStatus(league.id, newStatus);
                    const leagues = await getLeagues("false");
                    setLeagues(leagues);
                  }}>
                  {league.status === "ACTIVE" ? (
                    <IoCheckmarkCircle className='h-4 w-4 text-emerald-400/80' />
                  ) : (
                    <IoCloseCircle className='h-4 w-4 text-rose-400/80' />
                  )}
                </button>
              </article>
            ))
          ) : (
            <div className='flex h-40 flex-col items-center justify-center text-center'>
              <p className='text-xs text-white'>No hay ligas para mostrar.</p>
            </div>
          )}
        </div>
      </div>
    </AppContainer>
  );
};
